import {Extension} from '@tiptap/core';

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        tableCellBackgroundColor: {
            setTableCellBackgroundColor: (color: string) => ReturnType;
            unsetTableCellBackgroundColor: () => ReturnType;
        };
    }
}

export const TableCellBackgroundColor = Extension.create({
    name: 'tableCellBackgroundColor',

    addGlobalAttributes() {
        return [
            {
                types: ['tableCell', 'tableHeader'],
                attributes: {
                    backgroundColor: {
                        default: null,
                        parseHTML: (element) => element.style.backgroundColor || null,
                        renderHTML: (attributes) => {
                            if (!attributes.backgroundColor) {
                                return {};
                            }

                            return {
                                style: `background-color: ${attributes.backgroundColor}`,
                            };
                        },
                    },
                },
            },
        ];
    },

    addCommands() {
        return {
            setTableCellBackgroundColor:
                (color) =>
                ({tr, state, dispatch}) => {
                    const {selection} = state;
                    const {ranges} = selection;

                    let transaction = tr;

                    ranges.forEach(({$from, $to}) => {
                        state.doc.nodesBetween($from.pos, $to.pos, (node, pos) => {
                            if (node.type.name === 'tableCell' || node.type.name === 'tableHeader') {
                                transaction = transaction.setNodeMarkup(pos, undefined, {
                                    ...node.attrs,
                                    backgroundColor: color,
                                });
                            }
                        });
                    });

                    if (transaction.docChanged && dispatch) {
                        dispatch(transaction);
                        return true;
                    }

                    return false;
                },

            unsetTableCellBackgroundColor:
                () =>
                ({tr, state, dispatch}) => {
                    const {selection} = state;
                    const {ranges} = selection;

                    let transaction = tr;

                    ranges.forEach(({$from, $to}) => {
                        state.doc.nodesBetween($from.pos, $to.pos, (node, pos) => {
                            if (node.type.name === 'tableCell' || node.type.name === 'tableHeader') {
                                const newAttrs = {...node.attrs};
                                delete newAttrs.backgroundColor;

                                transaction = transaction.setNodeMarkup(pos, undefined, newAttrs);
                            }
                        });
                    });

                    if (transaction.docChanged && dispatch) {
                        dispatch(transaction);
                        return true;
                    }

                    return false;
                },
        };
    },
});
